export default __webpack_public_path__ + "static/media/telegram.ce3eea64.png";